import preloader from './preloader.gif';

export function Preloader({ style }: { style?: React.CSSProperties }) {
	return (
		<div className="preloader-container" style={{ display: 'flex', justifyContent: 'center', ...style }}>
			<img className="preloader" src={preloader} alt="Загрузка...." />
		</div>
	);
}
